<template>
  <div class="ca-pesquisa-vazio gap-size-5">
    <div class="ca-pesquisa-vazio__ilustracao" aria-hidden="true">
      <slot name="illustration">
        <IlustracaoPesquisa v-if="!illustration" />
        <img v-else :src="illustration" alt="" width="193" height="193" />
      </slot>
    </div>

    <p class="ca-pesquisa-vazio__titulo heading-small">
      Não conseguimos encontrar resultados para "{{ query }}"
    </p>
    <LinkButton
      v-if="suggestion"
      :label="`Será que não quis dizer: ${suggestion.label}`"
      @click="handleClick(suggestion)"
    />

    <div class="ca-pesquisa-vazio__dicas caption-large">
      <p class="ca-pesquisa-vazio__dicas-titulo">Sugestões:</p>
      <ul class="ca-pesquisa-vazio__dicas-lista pl-size-5 gap-size-2">
        <li>Verifique que nenhuma palavra tem erros ortográficos</li>
        <li>Tente outras palavras-chave</li>
        <li>Tente palavras-chave mais gerais</li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import IlustracaoPesquisa from "@assets/pesquisa-sem-resultados.svg";
import { LinkButton } from "ca-online-design-system";
const handleClick = (suggestion) => {
  if (suggestion?.url) {
    window.location.href = suggestion.url;
  }
};
defineProps({
  query: { type: String, default: "" },
  illustration: { type: String, default: "" },

  // { label: string, url: string } — sugestão de correcção ortográfica (Solr spell check)
  suggestion: { type: Object, default: null },
  temasRelacionados: { type: Array, default: () => [] },
});
</script>

<style scoped lang="scss">
.ca-pesquisa-vazio {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  &__ilustracao {
    width: 193px;
    height: 193px;
    flex-shrink: 0;
    overflow: hidden;
    margin: 0 auto var(--size-4);

    :deep(svg),
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  &__titulo {
    color: var(--ca-color-text-body-variant);
    margin: 0;
  }

  &__sugestao :deep(strong) {
    font-weight: inherit;
  }

  &__dicas {
    color: var(--ca-color-text-body-variant);
  }

  &__dicas-titulo {
    margin: 0 0 var(--size-3) 0;
  }

  &__dicas-lista {
    margin: 0;
    display: flex;
    flex-direction: column;
    list-style: disc;
  }
}
</style>
